/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSplash.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/**
 * 初期値
 */
let html = document.documentElement;
let splash = document.querySelector(".splash");


/**
 * 実行
 */
const setSplash = () => {
  splashLodingAnimation();
  window.addEventListener("DOMContentLoaded", () => {
    let $myWindow = "visited";
    if (window.name.indexOf($myWindow) != -1) {
      html.classList.add("--visited");
      complete();
    } else {
      window.name = $myWindow;
      window.addEventListener("load", () => {
        setTimeout(() => fvAnimation(), 3000);
      });
    }
    hintBrowser();
  });
};

/**
 * 処理
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function complete() {
  html.classList.remove("--loading");
  splash.remove();
}

function hintBrowser() {
  let willChangeItem = document.querySelectorAll(".--hintBrowser");
  if (willChangeItem.length === 0) return;
  willChangeItem.forEach((item) => item.classList.remove("--hintBrowser"));
}

function splashLodingAnimation() {
  let tl = gsap.timeline();
  let logo = document.querySelectorAll(".splash svg");
  let item = document.querySelectorAll(".splash .item");
  tl.to(logo, { opacity: 1, duration: 0.5, })
    .to(item, {
      duration: 0.2,
      opacity: 1,
      stagger: {
        each: 1,
        from: "end",
      }
    });
}

function fvAnimation() {
  let tl = gsap.timeline();

  //TOPページ
  const home = () => {
    let mv__logo = document.querySelector(".mv__logo h1");
    let bnr = document.querySelector(".fix-bnr img");
    gsap.set([mv__logo], { opacity: 0, yPercent: 25 });
    gsap.set([bnr], { yPercent: 10 });
    tl.to(splash, { duration: 1, opacity: 0, ease: "power2.easeOut", })
      .to(mv__logo, { duration: 2, opacity: 1, yPercent: 0, ease: "power4.easeOut", }, "<")
      .to([bnr], {
        duration: 1, yPercent: 0, autoAlpha: 1, ease: "power2.easeOut",
        onComplete: () => complete()
      }, "<+0.5");
  }

  //下層ページ
  const lower = () => {
    tl.to(splash, { duration: 1, opacity: 0, ease: "power2.easeOut", })
      .to(splash, { onComplete: () => complete() });
  }

  window.document.body.classList.contains("home") ? home() : lower();
}

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  setSplash
};